import React from 'react';
import shortcodeIdToFuncMap from '../shortcodeIdToFuncMap';
export const Shortcode = rendererClassName => props => {
  const {
    identifier,
    attributes
  } = props;
  const shortCodeMap = shortcodeIdToFuncMap.get(identifier);
  return shortCodeMap ? /*#__PURE__*/React.createElement("span", {
    className: rendererClassName
  }, shortCodeMap.shortcodeAttrsToResult(attributes)) : null;
};